<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="19" fill="none"><path fill="#f9fafb" d="M9.86 8.64c.507.47.507 1.29 0 1.758l-7.5 7.5a1.205 1.205 0 0 1-1.758 0 1.205 1.205 0 0 1 0-1.757L7.203 9.5.602 2.898a1.205 1.205 0 0 1 0-1.757 1.205 1.205 0 0 1 1.757 0z"/></svg>
</template>